import { Box, styled, Typography, Link, Theme } from '@mui/material';
import { FormWrapperMainLink } from 'view/pages/auth/components/Agreement/styled';
import { palette } from 'view/themes/palette';

export const FormWrapperFooter = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    width: '100%',
    marginTop: '40px',

    [theme.breakpoints.down('tablet')]: {
      marginTop: '32px',
    },
  };
}) as typeof Box;

export const FormWrapperFooterText = styled(Typography)({
  color: palette.text.body,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '22px',
  textAlign: 'center',
  whiteSpace: 'pre-line',
}) as typeof Typography;

// Наследуем стили
export const FormWrapperFooterLink = styled(FormWrapperMainLink)({
  fontSize: '16px',
  lineHeight: '21px',
}) as typeof Link;

export const FormWrapperFooterResendTimer = styled(Typography)({
  color: palette.text.body,
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '21px',
  opacity: 0.5,
  pointerEvents: 'none',
}) as typeof Typography;
